import React from 'react'
import {
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { Moment } from 'moment'
import { AddGoalInput, GoalCategory } from 'Generated/graphql-types'
import {
  Row,
  SelectContainer,
  Text,
  TextFieldContainer,
} from './FunderSharedGoals.styled'
import { CustomGoalCreationContainer } from './CustomGoalCreation.styled'
import { DatePicker } from '../../../SharedComponents/DatePicker/DatePicker'

type CustomGoalCreationProps = {
  goalToCreate: AddGoalInput
  onUpdateGoal: (updates: Record<string, string | Moment | null>) => void
}

const GOAL_DATE_FORMAT = 'YYYY-MM-DD'

export const CustomGoalCreation = ({
  goalToCreate,
  onUpdateGoal,
}: CustomGoalCreationProps) => (
  <CustomGoalCreationContainer>
    <Row>
      <Text>Goal Title:</Text>
      <TextFieldContainer>
        <TextField
          required
          label='Goal Title'
          value={goalToCreate.title}
          sx={{ minWidth: '700px' }}
          onChange={({ target: { value } }) => onUpdateGoal({ title: value })}
        />
      </TextFieldContainer>
    </Row>
    <Row>
      <Text>Goal Description:</Text>
      <TextFieldContainer>
        <TextField
          label='Goal Description'
          value={goalToCreate.description}
          sx={{ minWidth: '700px' }}
          onChange={({ target: { value } }) =>
            onUpdateGoal({ description: value })
          }
        />
      </TextFieldContainer>
    </Row>
    <Row>
      <Text>Goal Category:</Text>
      <SelectContainer>
        <FormControl>
          <InputLabel>Goal Type</InputLabel>
          <Select
            displayEmpty
            label={GoalCategory.Other}
            onChange={({ target: { value } }) =>
              onUpdateGoal({ category: value as GoalCategory })
            }
            required
            sx={{ minWidth: '300px' }}
            value={goalToCreate.category}
          >
            {Object.values(GoalCategory).map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </SelectContainer>
    </Row>
    <Row>
      <Text>Goal Targets:</Text>
      <DatePicker
        date={
          goalToCreate?.startDate
            ? goalToCreate.startDate.format(GOAL_DATE_FORMAT)
            : null
        }
        label='Start date (Optional)'
        onDateSelected={(value) => onUpdateGoal({ startDate: value })}
        styles={{ width: '50%' }}
      />
      <DatePicker
        date={
          goalToCreate?.endDate
            ? goalToCreate.endDate.format(GOAL_DATE_FORMAT)
            : null
        }
        label='End date (Optional)'
        onDateSelected={(value) => onUpdateGoal({ endDate: value })}
        styles={{ width: '50%' }}
      />
    </Row>
    <Divider />
  </CustomGoalCreationContainer>
)
